import { render, staticRenderFns } from "./QTSTickets.vue?vue&type=template&id=6efc6a24&scoped=true&"
import script from "./QTSTickets.vue?vue&type=script&lang=js&"
export * from "./QTSTickets.vue?vue&type=script&lang=js&"
import style0 from "./QTSTickets.vue?vue&type=style&index=0&id=6efc6a24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc6a24",
  null
  
)

export default component.exports